import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ style, isMobile }) {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    const lng = e.target.value;
    if (i18n && typeof i18n.changeLanguage === 'function') {
      i18n.changeLanguage(lng);
      localStorage.setItem('language', lng);
    }
  };

  const currentLanguage = i18n?.language || 'ka';

  const baseStyle = {
    fontSize: isMobile ? '13px' : '13px',
    fontWeight: '600',
    color: '#000',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    ...style
  };

  return (
    <select 
      style={baseStyle}
      value={currentLanguage}
      onChange={changeLanguage}
    >
      <option value="ka">KA</option>
      <option value="en">EN</option>
      <option value="ru">RU</option>
    </select>
  );
}